import { render } from "./practice-accounting-details.html?vue&type=template&id=3ac59ea0&scoped=true&ts=true&external"
import script from "./practice-accounting-details.ts?vue&type=script&lang=ts&external"
export * from "./practice-accounting-details.ts?vue&type=script&lang=ts&external"

import "./practice-accounting-details.scss?vue&type=style&index=0&id=3ac59ea0&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac59ea0"]])

export default __exports__